import { resolveValue, ToastBar, Toaster } from 'react-hot-toast'

import { CustomToastMessage } from '.'
import { toast, type ToastType } from './toast'

export const CustomToaster = () => {
  return (
    <Toaster
      toastOptions={{
        duration: Infinity,
      }}
    >
      {(t) => {
        const icon = t.icon as ToastType

        return (
          <ToastBar toast={t} position={t.position || 'top-center'} style={{ padding: '0', maxWidth: '424px' }}>
            {() => (
              <CustomToastMessage type={icon} onClose={() => toast.dismiss(t.id)}>
                {resolveValue(t.message, t)}
              </CustomToastMessage>
            )}
          </ToastBar>
        )
      }}
    </Toaster>
  )
}
